import script from "./BucketListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BucketListCard.vue?vue&type=script&setup=true&lang=js"

import "./BucketListCard.vue?vue&type=style&index=0&id=441eca8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441eca8a"]])

export default __exports__